import styles from './contactdropdown.module.scss';
import Icons from '@components/Icons';

/**
 * Contact Dropdown component for navbar
 * 
 * @param props - The props for the component
 * @param props.contactvisible - The visibility state of the contact dropdown
 * @param props.toggle - The function to toggle the contact dropdown
 * @returns - The Contact Dropdown component JSX.Element
 *
 * @example
 * ```tsx
 * <ContactDropdown
 *  contactvisible={contactvisible}
 *  toggle={toggle}
 * />
 * ```
 */
const _ContactDropdown = ({
    contactVisible,
    toggle,
}: {
    contactVisible: boolean;
    toggle: () => void;
}) => {
    return (
        <div
            role="dialog"
            aria-label="Contact information"
            className={`
            ${styles.contactcontainer} 
            ${contactVisible ? styles.contactcontainershow : styles.contactcontainerhide}
            `}
            inert={!contactVisible}
            aria-hidden={!contactVisible}
            onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                e.preventDefault();
                toggle();
            }}
        >
            <p>
                <b>The Crocodile Hunter Lodge</b>
            </p>
            <p>
                <a href="tel:+61754362300">
                    +617 5436 2300 &nbsp;
                    <Icons iconClass={`general-telephone-fill`} />
                </a>
            </p>
            <p>
                <a href="mailto:reservations@thecrocodilehunterlodge.com.au">
                    reservations@thecrocodilehunterlodge.com.au &nbsp;
                    <Icons iconClass={`general-envelope-fill`} />
                </a>
            </p>
            <hr />
            <p>
                <b>Warrior Restaurant {`\&`} Bar</b>
            </p>
            <p>
                <a href="tel:+61754362310">
                    +617 5436 2310 &nbsp;
                    <Icons iconClass={`general-telephone-fill`} />
                </a>
            </p>

            <p>
                <a href="mailto:warrior@thecrocodilehunterlodge.com.au">
                    warrior@thecrocodilehunterlodge.com.au &nbsp;
                    <Icons iconClass={`general-envelope-fill`} />
                </a>
            </p>
        </div>
    );
};

export default _ContactDropdown;
